export const PendingChangeAuthorDotsTestIds = {
  DOTS: 'pending-change-authors.dots-label',
};
